import { put, select } from '@redux-saga/core/effects';
import { CONTACTS_PER_PAGE } from 'appConstants/emailMarketing';
import { getUnsubscribedContacts } from '../selectors';
import { ApiGateway } from '../../../../services/apiGateway';
import { unsubscribedContactsActions } from './actions';
import { fetchContacts } from '../../utils';

export function* fetchUnsubscribedContacts({ payload }: any) {
  const state = getUnsubscribedContacts(yield select());
  yield fetchContacts(payload, state, ApiGateway.fetchUnsubscribed, {
    success: unsubscribedContactsActions.fetchContacts.success,
    failure: unsubscribedContactsActions.fetchContacts.failure,
    setList: unsubscribedContactsActions.setContactsList
  });
}

export function* setUnsubscribedSortFieldAndOrder({
  payload
}: ReturnType<typeof unsubscribedContactsActions.setUnsubscribedSortFieldAndOrder>) {
  const state = yield select();
  const contacts = getUnsubscribedContacts(state);
  yield put(
    unsubscribedContactsActions.fetchContacts.request({
      page: contacts.page,
      limit: contacts.limit || CONTACTS_PER_PAGE,
      keyword: contacts.keyword,
      sort: payload
    })
  );
}
